import { render, staticRenderFns } from "./CommunityFilters.vue?vue&type=template&id=3e64e1f3"
import script from "./CommunityFilters.vue?vue&type=script&lang=js"
export * from "./CommunityFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports